import { create } from 'zustand'
import { DomainContextProps } from './storeTypes/domain.storeTypes'




const useDomainStore = create<DomainContextProps>((set) => ({
  complexity:[],
  setComplexity:(data)=>set(()=>({complexity:data})),
  language:[],
  setLanguage:(data)=>set(()=>({language:data})),
  marks:[],
  setMarks:(data)=>set(()=>({marks:data})),
  subjects:[],
  setSubjects:(data)=>set(()=>({subjects:data}))

}))

export default useDomainStore